import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {LocalStorageService} from '../../../services/local-storage.service';

@Component({
  selector: 'app-ai-tune-settings-dialog',
  templateUrl: './ai-tune-settings-dialog.component.html',
  styleUrls: ['./ai-tune-settings-dialog.component.scss']
})
export class AiTuneSettingsDialogComponent implements OnInit {

  public randomSettings = {
    count: 100,
    min_length: 30,
    max_length: 50,
  }
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialogRef: MatDialogRef<AiTuneSettingsDialogComponent>,
    private localStorageService: LocalStorageService
  ) {

  }

  ngOnInit(): void {
    const settings = this.localStorageService.getItem('ai_tune_settings');
    if (settings) {
      this.randomSettings.count = settings.count;
      this.randomSettings.min_length = settings.min_length;
      this.randomSettings.max_length = settings.max_length;
    }
  }

  onSave(): void {
    // console.log('qwer');
    this.localStorageService.setItem('ai_tune_settings', this.randomSettings);
    this.dialogRef.close();
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
